import { ActionIcon, ActionIconProps, ElementProps } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { ChevronsLeft } from 'lucide-react';
import { forwardRef } from 'react';
import { RegistryModel, Row } from 'shared/lib';

export type RegistryPaginationControlsStartProps = ActionIconProps &
	ElementProps<'button', keyof ActionIconProps>;

export const createRegistryPaginationControlsStart = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
	TAdditionalData = unknown,
>(
	model: RegistryModel<TRow, TFilters, TError, TAdditionalData>,
) => {
	const RegistryPaginationControlsStart = forwardRef<
		HTMLButtonElement,
		RegistryPaginationControlsStartProps
	>(({ className, children, onClick, ...props }, ref) => {
		const [click, disabled] = useUnit([
			model.paginationStartClicked,
			model.$paginationStartDisabled,
		]);

		return (
			<ActionIcon
				ref={ref}
				data-test-id='registry-pagination-controls-start'
				disabled={disabled}
				variant='outline'
				size='sm'
				className={clsx('registry-pagination-controls-start', className)}
				onClick={(event) => {
					click();
					onClick?.(event);
				}}
				{...props}
			>
				{children ?? <ChevronsLeft />}
			</ActionIcon>
		);
	});

	return RegistryPaginationControlsStart;
};
